{
  "schemaVersion": "1.0.0",
  "scenarioId": "Invalid Scenario!",
  "payload": {
    "records": [{ "id": 1, "full_name": "Test" }]
  },
  "options": {},
  "extra": "propiedad no permitida en la envolvente"
}
